<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3214_104667)">
<circle cx="1.25" cy="11" r="1.25" fill="#333333"/>
<circle cx="6" cy="11" r="1.25" fill="#333333"/>
<circle cx="10.75" cy="11" r="1.25" fill="#333333"/>
<path d="M14 7C14 6.60156 14.3281 6.25 14.75 6.25H20.75C21.0078 6.25 21.2656 6.41406 21.3828 6.64844C21.5234 6.88281 21.5234 7.16406 21.3828 7.39844L16.1328 16.3984C15.9219 16.75 15.4766 16.8672 15.1016 16.6562C14.75 16.4453 14.6328 16 14.8438 15.625L19.4375 7.75H14.75C14.3281 7.75 14 7.42188 14 7Z" fill="#333333"/>
</g>
<defs>
<clipPath id="clip0_3214_104667">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
